import { CONTENT_SIDEBAR_MODE } from '@/shared/enums/common.enum';
import { Pagination } from '@/shared/models/pagination.model';
import Vue from 'vue';
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import { IResponseGetCourseTemplates } from '../interfaces/response-get-course-templates.interface';
import { ISetTemplateModeStoreParams } from '../params/set-template-mode-store.params';
import { CourseTemplateService } from '../services/course-templates.service';
import { TEMPLATE_SCOPE, PURCHASE_TYPES } from '@/course-templates/values/course-templates.values';
import { i18n } from '@/core/lang/core.i18n';
import { CourseTemplate } from '../models/course-template.model';
import { RequestProvider } from '@/shared/providers/request.provider';

@Module({ namespaced: true })
export class CourseTemplateStore extends VuexModule {

  /* State */
  courseTemplates = new Pagination(); /* Deprectaed */
  publicCourseTemplates = new Pagination();
  privateCourseTemplates = new Pagination();
  purchasedContentTemplates = new Pagination();
  myContentTemplates = new Pagination();
  templatesGradeLevelsOptions = [];
  templatesGradeLevelSelected = null;
  myCourseTemplates = new Pagination();
  sharedContentTemplates = new Pagination();
  purchasedContentTemplatesFirstTime : boolean = false;
  myCourseTemplatesFirstTime : boolean = false;
  sharedContentTemplatesFirstTime : boolean = false;
  publicContentTemplatesFirstTime : boolean = false;
  privateContentTemplatesFirstTime : boolean = false;

  /* Mutations */
  @Mutation
  public async initCourseTemplates(gradeLevelSelected = null) {
    this.purchasedContentTemplates = new Pagination();
    await Vue.prototype.$CourseTemplates.Store.getMyCourseTemplates(PURCHASE_TYPES.PURCHASE, gradeLevelSelected);
    this.myContentTemplates = new Pagination();
    await Vue.prototype.$CourseTemplates.Store.getMyCourseTemplates(PURCHASE_TYPES.OWNER, gradeLevelSelected);
    this.sharedContentTemplates = new Pagination();
    await Vue.prototype.$CourseTemplates.Store.getMyCourseTemplates(PURCHASE_TYPES.SHARED_WITH, gradeLevelSelected);
    return;
  }

  @Mutation
  public initMyContentTemplate(purchaseTypes) {
    switch(purchaseTypes) {
      case PURCHASE_TYPES.OWNER:
        this.myContentTemplates = new Pagination();
      break;
      case PURCHASE_TYPES.PURCHASE:
        this.purchasedContentTemplates = new Pagination();
      break;
      case PURCHASE_TYPES.SHARED_WITH:
        this.sharedContentTemplates = new Pagination();
      break;
      case TEMPLATE_SCOPE.PUBLIC:
        this.publicCourseTemplates = new Pagination();
      break;
      case TEMPLATE_SCOPE.ORGANIZATION:
        this.privateCourseTemplates = new Pagination();
      break;
    }
  }

  @Mutation
  public setFirstTimeContentTemplate({purchaseTypes, value}) {
    switch(purchaseTypes) {
      case PURCHASE_TYPES.OWNER:
        this.myCourseTemplatesFirstTime = value;
      break;
      case PURCHASE_TYPES.PURCHASE:
        this.purchasedContentTemplatesFirstTime = value;
      break;
      case PURCHASE_TYPES.SHARED_WITH:
        this.sharedContentTemplatesFirstTime = value;
      break;
      case TEMPLATE_SCOPE.PUBLIC:
        this.publicContentTemplatesFirstTime = value;
      break;
      case TEMPLATE_SCOPE.ORGANIZATION:
        this.privateContentTemplatesFirstTime = value;
      break;
    }
  }

  /* Deprectaed */
  @Mutation
  public setCourseTemplates(data: IResponseGetCourseTemplates) {
    let currentCT = this.courseTemplates.content;
    this.courseTemplates.content = currentCT.concat(data.courseTemplates);
    this.courseTemplates.page++;
    this.courseTemplates.more = data.totalPages > this.courseTemplates.page;
  }

  @Mutation
  public setPublicCourseTemplates(data: IResponseGetCourseTemplates) {
    let currentCT = this.publicCourseTemplates.content;
    this.publicCourseTemplates.content = currentCT.concat(data.courseTemplates);
    this.publicCourseTemplates.page++;
    this.publicCourseTemplates.more = data.totalPages > this.publicCourseTemplates.page;
  }

  @Mutation
  public setPrivateCourseTemplates(data: IResponseGetCourseTemplates) {
    let currentCT = this.privateCourseTemplates.content;
    this.privateCourseTemplates.content = currentCT.concat(data.courseTemplates);
    this.privateCourseTemplates.page++;
    this.privateCourseTemplates.more = data.totalPages > this.privateCourseTemplates.page;
  }

  @Mutation
  public setMyCourseTemplates(data: IResponseGetCourseTemplates) {
    const currentCT = this.myCourseTemplates.content;
    const courseTemplates = data.courseTemplates || [];
    const content = courseTemplates.map(ct => new CourseTemplate(ct));

    this.myCourseTemplates.content = currentCT.concat(content);
    this.myCourseTemplates.page++;
    this.myCourseTemplates.more = data.totalPages > this.myCourseTemplates.page;
  }

  @Mutation
  public setMyContentTemplates(data: IResponseGetCourseTemplates) {
    let currentCT = this.myContentTemplates.content;
    let newCT = data.courseTemplates.map(data => ({
      data: new CourseTemplate({ ...data } as any),
      mode: CONTENT_SIDEBAR_MODE.VIEWER,
      component: null
    }));
    this.myContentTemplates.content = currentCT.concat(newCT.filter((newObject) => !currentCT.some((currentObject) => currentObject.data.id === newObject.data.id)));
    this.myContentTemplates.page++;
    this.myContentTemplates.more = data.totalPages > this.myContentTemplates.page;
  }

  @Mutation
  public setPurchasedTemplates(data: IResponseGetCourseTemplates) {
    let currentCT = this.purchasedContentTemplates.content;
    let newCT = data.courseTemplates.map(data => ({
      data: new CourseTemplate({ ...data } as any),
      mode: CONTENT_SIDEBAR_MODE.VIEWER,
      component: null
    }));
    this.purchasedContentTemplates.content = currentCT.concat(newCT.filter((newObject) => !currentCT.some((currentObject) => currentObject.data.id === newObject.data.id)));
    this.purchasedContentTemplates.page++;
    this.purchasedContentTemplates.more = data.totalPages > this.purchasedContentTemplates.page;
  }

  @Mutation
  public setSharedTemplates(data: IResponseGetCourseTemplates) {
    let currentCT = this.sharedContentTemplates.content;
    let newCT = data.courseTemplates.map(data => ({
      data: new CourseTemplate({ ...data } as any),
      mode: CONTENT_SIDEBAR_MODE.VIEWER,
      component: null
    }));
    this.sharedContentTemplates.content = currentCT.concat(newCT.filter((newObject) => !currentCT.some((currentObject) => currentObject.data.id === newObject.data.id)));
    this.sharedContentTemplates.page++;
    this.sharedContentTemplates.more = data.totalPages > this.sharedContentTemplates.page;
  }

  @Mutation
  public setTemplateMode({ templateId, mode, section }: ISetTemplateModeStoreParams) {
    const template = this[`${section}ContentTemplates`].content.find(t => t.data.id === templateId);
    template.mode = mode;
  }

  @Mutation
  public updateSectionVisibleMode({ sectionId, templateId, teacherOnly }) {
    const templateIndex = this.myContentTemplates.content.findIndex(t => t.data.id === templateId);
    const template = this.myContentTemplates.content[templateIndex];
    const section = Vue.prototype.$CourseTemplates.Provider.getSection(template.data.sections, sectionId);
    section.teacherOnly = teacherOnly;
  }

  @Mutation
  public setGradeLevels(data) {
    this.templatesGradeLevelsOptions = data
      .sort((a, b) => a.order - b.order)
      .map(el => { return { text: el.name, value: el.id } });
      this.templatesGradeLevelsOptions.unshift({text: i18n.t('myContent.seeAll'), value: ''})
  } 

  @Mutation
  public async setChangesCourseTemplates() {
    this.publicCourseTemplates = new Pagination();
    this.privateCourseTemplates = new Pagination();
    this.purchasedContentTemplates = new Pagination();
    await Vue.prototype.$CourseTemplates.Store.getCourseTemplates(TEMPLATE_SCOPE.ORGANIZATION);
    await Vue.prototype.$CourseTemplates.Store.getCourseTemplates(TEMPLATE_SCOPE.PUBLIC);
    return;
  }

  @Mutation
  resetCourseTemplates() {
    this.publicCourseTemplates = new Pagination();
    this.privateCourseTemplates = new Pagination();
    this.myCourseTemplates = new Pagination();
  }
  
  @Mutation
  public setGradeLevelSelected(gradeLevel) {
    this.templatesGradeLevelSelected = gradeLevel;
  }

  @Mutation
  public removeCourseTemplateM(templateId) {
    this.myContentTemplates.content = this.myContentTemplates.content.filter(el => el.data.id !== templateId);
    this.myCourseTemplates.content = this.myCourseTemplates.content.filter(el => el.id !== templateId);
  }

  @Mutation
  public unblockCourseTemplateM(templateId) {
    this.myContentTemplates.content = this.myContentTemplates.content.map(el => {
      if (templateId === el.data.id) return { ...el, data: { ...el.data, locked: false } }
      else return el
    });
    this.purchasedContentTemplates.content = this.purchasedContentTemplates.content.map(el => {
      if (templateId === el.data.id) return { ...el, data: { ...el.data, locked: false } }
      else return el
    })
  }

  @Mutation
  public blockCourseTemplateM(templateId) {
    this.myContentTemplates.content = this.myContentTemplates.content.map(el => {
      if (templateId === el.data.id) return { ...el, data: { ...el.data, locked: true } }
      else return el
    });
    this.purchasedContentTemplates.content = this.purchasedContentTemplates.content.map(el => {
      if (templateId === el.data.id) return { ...el, data: { ...el.data, locked: true } }
      else return el
    })
  }

  @Mutation
  updateCourseTemplateStatus({ templateId, status }) {
    this.myContentTemplates.content = this.myContentTemplates.content.map(t => {
      if (t.data.id === templateId) {
        return {...t, data: new CourseTemplate({...t.data, status })};
      }
      return t;
    });
    this.purchasedContentTemplates.content = this.purchasedContentTemplates.content.map(t => {
      if (t.id === templateId) {
        return {...t, data: new CourseTemplate({...t.data, status })};
      }
      return t;
    })
  }

  /* Actions */
  @Action({})
  public createCourseTemplate({ courseId, isPublic }): Promise<void> {
    return new Promise((resolve, reject) => {
      CourseTemplateService.createCourseTemplate(courseId, isPublic)
        .then(res => {
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    }); 
  }

  @Action({})
  public getCourseTemplates(scope = null): Promise<void> {
    return new Promise((resolve, reject) => {
      let page, pageSize;
      switch(scope) {
        case TEMPLATE_SCOPE.ORGANIZATION:
            page = this.privateCourseTemplates.page;
            pageSize = this.privateCourseTemplates.pageSize;
          break;
          case TEMPLATE_SCOPE.PUBLIC:
            page = this.publicCourseTemplates.page;
            pageSize = this.publicCourseTemplates.pageSize;
          break;
          default:
            page = this.courseTemplates.page;
            pageSize = this.courseTemplates.pageSize;
          break;
      }
      CourseTemplateService.getCourseTemplates(
        page,
        pageSize, 
        scope
      )
      .then(res => {
        switch(scope) {
          case TEMPLATE_SCOPE.ORGANIZATION:
            Vue.prototype.$CourseTemplates.Store.setPrivateCourseTemplates(res);
          break;
          case TEMPLATE_SCOPE.PUBLIC:
            Vue.prototype.$CourseTemplates.Store.setPublicCourseTemplates(res);
          break;
          default:
            Vue.prototype.$CourseTemplates.Store.setCourseTemplates(res);
          break;
        }
        resolve();
      })
      .catch(err => {
        reject(err);
      });
    }); 
  }

  @Action({})
  public createCourseFromTemplate(courseTemplateId): Promise<void> {
    return new Promise((resolve, reject) => {
      CourseTemplateService.createCourseFromTemplate(courseTemplateId)
        .then(res => {
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    }); 
  }


  @Action({rawError: true})
  public async getCourseTemplate(data) {
    const res = await Vue.prototype.$CourseTemplates.Services.getCourseTemplate(
      data.templateId,
    );

    return {
      id: res.contentId,
      title: res.contentTitle,
      img: res.coverThumbnailSmallUrl,
      defaultDueDateForTasks: res.defaultDueDateForTasks,
      defaultLastDateForTasks: res.defaultLastDateForTasks,
      contentSummary: res.contentSummary,
      categoryId: res.category.id,
      imgHash: res.coverImg,
      hasGrading: res.hasGrading,
      actualGrade: res.actualGrade,
      suggestedGrade: res.suggestedGrade,
      schoolCalendar: res.schoolDay,
      duration: res.duration,
      components: res.components,
      suggestedLessonDuration: res.suggestedLessonDuration,
    }
  }
  
  @Action({})
  public getMyCourseTemplates({purchaseTypes, gradeLevelIds}): Promise<void> {
    return new Promise((resolve, reject) => {
      let page, pageSize;
      switch(purchaseTypes) {
        case PURCHASE_TYPES.OWNER:
          page = this.myContentTemplates.page;
          pageSize = this.myContentTemplates.pageSize;
        break;
        case PURCHASE_TYPES.PURCHASE:
          page = this.purchasedContentTemplates.page;
          pageSize = this.purchasedContentTemplates.pageSize
        break;
        case PURCHASE_TYPES.SHARED_WITH:
          page = this.sharedContentTemplates.page;
          pageSize = this.sharedContentTemplates.pageSize
        break;
        default:
          page = this.myCourseTemplates.page;
          pageSize = this.myCourseTemplates.pageSize
        break;
      }
      CourseTemplateService.getMyCourseTemplates(
        page,
        pageSize,
        purchaseTypes ? purchaseTypes : TEMPLATE_SCOPE.OWNER,
        gradeLevelIds
      )
      .then(res => {
        switch(purchaseTypes) {
          case PURCHASE_TYPES.OWNER:
            Vue.prototype.$CourseTemplates.Store.setMyContentTemplates(res);
          break;
          case PURCHASE_TYPES.PURCHASE:
            Vue.prototype.$CourseTemplates.Store.setPurchasedTemplates(res);
          break;
          case PURCHASE_TYPES.SHARED_WITH:
            Vue.prototype.$CourseTemplates.Store.setSharedTemplates(res);
          break;
          default:
            Vue.prototype.$CourseTemplates.Store.setMyCourseTemplates(res);
          break;
        }
        resolve();
      })
      .catch(err => {
        reject(err);
      });
    }); 
  }

  @Action({rawError: true})
  public async getGradeLevels(orgId) {
    let data = await Vue.prototype.$CourseTemplates.Services.getGradeLevels(orgId);
    Vue.prototype.$CourseTemplates.Store.setGradeLevels(data);
    return data
  }
  
  @Action({rawError: true})
  public async publishCourseTemplate({templateId, templateScope}) {
    await Vue.prototype.$CourseTemplates.Services.publishCourseTemplate(templateId, templateScope);
    Vue.prototype.$CourseTemplates.Store.setChangesCourseTemplates();
  }

  @Action({rawError: true})
  public async removeCourseTemplate(templateId) {
    await Vue.prototype.$CourseTemplates.Services.removeCourseTemplate(templateId);
    Vue.prototype.$CourseTemplates.Store.removeCourseTemplateM(templateId);
  }

  @Action({rawError:true})
  public async blockCourseTemplate(templateId) {
    await Vue.prototype.$CourseTemplates.Services.lockCourseTemplate(templateId);
    Vue.prototype.$CourseTemplates.Store.blockCourseTemplateM(templateId);
  }

  @Action({rawError:true})
  public async unblockCourseTemplate(templateId) {
    await Vue.prototype.$CourseTemplates.Services.unlockCourseTemplate(templateId);
    Vue.prototype.$CourseTemplates.Store.unblockCourseTemplateM(templateId);
  }

  @Action({ rawError: true })
  getCourseTemplateStatusById(templateId) {
    return CourseTemplateService.getCourseTemplateById(templateId).then((courseTemplateResponse) => {
      Vue.prototype.$CourseTemplates.Store.updateCourseTemplateStatus(
        templateId,
        courseTemplateResponse.status
      );
    });
  }

  /* Initial State */
  @Mutation
  public initState(state) {
    this.courseTemplates = new Pagination();
    this.publicCourseTemplates = new Pagination();
    this.privateCourseTemplates = new Pagination();
    this.purchasedContentTemplates = new Pagination();
    this.myContentTemplates = new Pagination();
    this.templatesGradeLevelsOptions = [];
    this.templatesGradeLevelSelected = null;
    this.myCourseTemplates = new Pagination();
    this.sharedContentTemplates = new Pagination();
    this.purchasedContentTemplatesFirstTime = false;
    this.myCourseTemplatesFirstTime = false;
    this.sharedContentTemplatesFirstTime = false;
    this.publicContentTemplatesFirstTime = false;
    this.privateContentTemplatesFirstTime = false;
  }

}